import React, { useEffect, useRef, useState } from 'react'
import Avatar from '@mui/material/Avatar'
import Button from '@mui/material/Button'
import CssBaseline from '@mui/material/CssBaseline'
import TextField from '@mui/material/TextField'
import Link from '@mui/material/Link'
import Paper from '@mui/material/Paper'
import Box from '@mui/material/Box'
import Grid from '@mui/material/Grid'
import LockOutlinedIcon from '@mui/icons-material/LockOutlined'
import Typography from '@mui/material/Typography'
import { createTheme, ThemeProvider } from '@mui/material/styles'
import { useLogin, useNotify } from 'react-admin'
import Copyright from '../../components/Copyright'
import API from '../../services/api'

import Background from '../../assets/images/background.png'

const theme = createTheme()

const SignInSide = () => {
  const login = useLogin()
  const notify = useNotify()

  const [isRegistering, setIsRegistering] = useState(false)

  const handleSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
    try {
      event.preventDefault()
      const data = new FormData(event.currentTarget)

      const password = data.get('password') as string

      if (password && password.length < 6) {
        return notify('A senha deve ter no mínimo 6 caracteres', { type: 'error' })
      }

      const userData = {
        name: data.get('name') as string,
        email: data.get('email') as string,
        password,
      }

      if (isRegistering) {
        await API.post('/users', userData)

        setIsRegistering(false)

        return notify('Cadastrado com sucesso!', { type: 'success' })
      }

      login({ email: userData.email, password: userData.password }).catch((error) => {
        if (error.response.data.status === 422) {
          return notify('Algum campo não foi informado', { type: 'error' })
        }

        return notify('Email ou senha inválidos', { type: 'error' })
      })
    } catch (error: any) {
      if (error.response.data.status === 422) {
        return notify('Algum campo não foi informado', { type: 'error' })
      }

      if (error.response.data.status === 409) {
        return notify('Esse e-mail já foi utilizado por outra pessoa', { type: 'error' })
      }

      notify('Ocorreu um erro, tente novamente.', { type: 'error' })
    }
  }

  return (
    <ThemeProvider theme={theme}>
      <Grid container component="main" sx={{ height: '100vh' }}>
        <CssBaseline />
        <Grid
          item
          xs={false}
          sm={4}
          md={7}
          sx={{
            backgroundImage: `url(${Background})`,
            backgroundRepeat: 'no-repeat',
            backgroundColor: (t) =>
              t.palette.mode === 'light' ? t.palette.grey[50] : t.palette.grey[900],
            backgroundSize: 'cover',
            backgroundPosition: 'center',
          }}
        />
        <Grid item xs={12} sm={8} md={5} component={Paper} elevation={6} square>
          <Box
            sx={{
              my: 8,
              mx: 4,
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
            }}
          >
            <Avatar sx={{ m: 1, bgcolor: '#00A76F' }}>
              <LockOutlinedIcon />
            </Avatar>
            <Typography component="h1" variant="h5">
              {isRegistering ? 'Cadastrar' : 'Entrar'}
            </Typography>
            <Box component="form" maxWidth="28vw" noValidate onSubmit={handleSubmit} sx={{ mt: 1 }}>
              {isRegistering && (
                <TextField margin="normal" required fullWidth id="name" label="Nome" name="name" />
              )}
              <TextField
                margin="normal"
                required
                fullWidth
                id="email"
                type="email"
                label="Email"
                name="email"
              />
              <TextField
                margin="normal"
                required
                fullWidth
                name="password"
                label="Senha"
                type="password"
                id="password"
              />
              <Button
                type="submit"
                fullWidth
                variant="contained"
                sx={{
                  'mt': 3,
                  'mb': 2,
                  'backgroundColor': '#00A76F',
                  ':hover': { backgroundColor: '#007867' },
                }}
              >
                {isRegistering ? 'Cadastrar' : 'Entrar'}
              </Button>
              <Grid container>
                {!isRegistering && (
                  <Grid item xs>
                    <Link style={{ cursor: 'pointer', color: '#00A76F' }} variant="body2">
                      Esqueceu a senha?
                    </Link>
                  </Grid>
                )}
                <Grid item>
                  <Link
                    style={{ cursor: 'pointer', color: '#00A76F' }}
                    variant="body2"
                    onClick={() => setIsRegistering(!isRegistering)}
                  >
                    {isRegistering ? 'Voltar' : 'Não tem uma conta? Cadastre-se'}
                  </Link>
                </Grid>
              </Grid>
              <Copyright sx={{ mt: 5 }} />
            </Box>
          </Box>
        </Grid>
      </Grid>
    </ThemeProvider>
  )
}

export default SignInSide
